import script from "./HedgeAssistView.vue?vue&type=script&setup=true&lang=js"
export * from "./HedgeAssistView.vue?vue&type=script&setup=true&lang=js"

import "./HedgeAssistView.vue?vue&type=style&index=0&id=016d8939&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016d8939"]])

export default __exports__